import { CorporateReportsTrendsComponent } from './modules/main-landing-page/corporate-reports-trends/corporate-reports-trends.component';
import { CorporateMagazinesTrendsComponent } from './modules/main-landing-page/corporate-magazines-trends/corporate-magazines-trends.component';
import { CorporateTodayTrendsComponent } from './modules/main-landing-page/corporate-today-trends/corporate-today-trends.component';
import {APP_INITIALIZER, isDevMode, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {SharedModule} from "./shared/shared.module";
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {effects} from "./store/effects";
import {EffectsModule} from '@ngrx/effects';
import {MAT_DATE_LOCALE} from "@angular/material/core";
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {AuthInterceptor} from "./guards/auth-interceptor";
import {GraphQLModule} from './graphql.module';
import {NgxPermissionsModule, NgxPermissionsService} from "ngx-permissions";
import {PageComponent} from './page/page.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {CustomTranslateLoader} from "./services/custom-translate-loader";
import {CONFIGURATION_TOKEN} from "./app.tokens";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {Apollo} from "apollo-angular";
import {InitTranslationService} from "./services/init-translation.service";
import { UserManagementService } from './services/user-management.service';
import { provideNgxMask } from 'ngx-mask';
import {CommonModule, DatePipe} from "@angular/common";
import {LoadingBarHttpClientModule} from "@ngx-loading-bar/http-client";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import {LoginComponent} from "./guest/login/login.component";
import {ForgotPasswordComponent} from "./guest/forgot-password/forgot-password.component";
import {CheckYourEmailComponent} from "./guest/check-your-email/check-your-email.component";
import {ResetPasswordComponent} from "./guest/reset-password/reset-password.component";
import {SetPasswordComponent} from "./guest/set-password/set-password.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MainLandingPageComponent } from './modules/main-landing-page/main-landing-page.component';
import { ModalHeaderComponent } from './shared/components/modal-header/modal-header.component';
import { CreateUpdateWorkflowComponent } from './modules/work-flow/create-update-workflow/create-update-workflow.component';
import { StagesListComponent } from './modules/work-flow/stages-list/stages-list.component';
import { WorkFlowComponent } from './modules/work-flow/work-flow.component';
import { CreateUpdateStageComponent } from './modules/work-flow/stages-list/create-update-stage/create-update-stage.component';
import { ArticlesManagementModule } from './modules/articles-management/articles-management.module';

import { HugeiconsIconComponent } from "@hugeicons/angular";
import { ArticleByGazetiComponent } from './modules/main-landing-page/article-by-gazeti/article-by-gazeti.component';
import { FooterComponent } from './modules/main-landing-page/footer/footer.component';
import { TodayTrendSectionComponent } from './modules/main-landing-page/today-trend-section/today-trend-section.component';
import { BookTrendSectionComponent } from './modules/main-landing-page/book-trend-section/book-trend-section.component';
import { MagazineTrendSectionComponent } from './modules/main-landing-page/magazine-trend-section/magazine-trend-section.component';
import { ReportTrendSectionComponent } from './modules/main-landing-page/report-trend-section/report-trend-section.component';
import { LandingSubscriptionComponent } from './modules/main-landing-page/landing-subscription/landing-subscription.component';
import { PaymentModalComponent } from './modules/main-landing-page/payment-modal/payment-modal.component';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { CorporateLandingComponent } from './modules/main-landing-page/corporate-landing/corporate-landing.component';
import { CorporateBooksTrendsComponent } from './modules/main-landing-page/corporate-books-trends/corporate-books-trends.component';
import { CorporateBillingComponent } from './modules/main-landing-page/corporate-billing/corporate-billing.component';
import { CorporateSubscriptionComponent } from './modules/main-landing-page/corporate-subscription/corporate-subscription.component';
import { CorporateReadersComponent } from './modules/main-landing-page/corporate-readers/corporate-readers.component';
import { StoriesSectionComponent } from './modules/main-landing-page/stories-section/stories-section.component';
import { CorporateBillingViewComponent } from './modules/main-landing-page/corporate-billing/corporate-billing-view/corporate-billing-view.component';
import { CorporateSubscriptionViewComponent } from './modules/main-landing-page/corporate-subscription/corporate-subscription-view/corporate-subscription-view.component';
import { CorporateReadersViewComponent } from './modules/main-landing-page/corporate-readers/corporate-readers-view/corporate-readers-view.component';
import { PremiumStoriesComponent } from './modules/main-landing-page/premium-stories/premium-stories.component';
import { CorporatePaymentComponent } from './modules/main-landing-page/corporate-payment/corporate-payment.component';
import { CorporatePaymentViewComponent } from './modules/main-landing-page/corporate-payment/corporate-payment-view/corporate-payment-view.component';
import { GazetPreviewComponent } from './modules/main-landing-page/gazet-preview/gazet-preview.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        PageComponent,
      LoginComponent,
      ForgotPasswordComponent,
      CheckYourEmailComponent,
      ResetPasswordComponent,
      SetPasswordComponent,
          CreateUpdateWorkflowComponent,
      MainLandingPageComponent,
      ArticleByGazetiComponent,
      FooterComponent,
      GazetPreviewComponent,
      TodayTrendSectionComponent,
     BookTrendSectionComponent,
     MagazineTrendSectionComponent,
     ReportTrendSectionComponent,
     LandingSubscriptionComponent,
     PaymentModalComponent,
     CorporateLandingComponent,
     CorporateTodayTrendsComponent,
     CorporateBooksTrendsComponent,
     CorporateMagazinesTrendsComponent,
     CorporateReportsTrendsComponent,
     CorporateBillingComponent,
      CorporateSubscriptionComponent,
      CorporateReadersComponent,
     StoriesSectionComponent,
     PremiumStoriesComponent,
     CorporateBillingViewComponent,
     CorporateSubscriptionViewComponent,
     CorporateReadersViewComponent,
     CorporatePaymentComponent,
     CorporatePaymentViewComponent,
  


      
      
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LoadingBarHttpClientModule,
        LoadingBarModule,
        HugeiconsIconComponent,
        SharedModule,
        FormsModule,
        CommonModule,
      
        NgApexchartsModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateSerializability: false,
                strictActionSerializability: false,
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictActionWithinNgZone: true,
                strictActionTypeUniqueness: true,
            }
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: !isDevMode(),
            autoPause: true,
            trace: false,
            traceLimit: 75,
        }),
        EffectsModule.forRoot(effects),
        GraphQLModule,
        NgxPermissionsModule.forRoot(),
        TranslateModule.forRoot({
            // loader: {
            //     provide: TranslateLoader,
            //     useClass: CustomTranslateLoader,
            //     deps: [Apollo]
            // }
        })
    ],
    providers: [
        DatePipe,
        provideAnimationsAsync(),
        provideNgxMask(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: CONFIGURATION_TOKEN,
            useValue: 'to be used later for translation storage and use translation on components',
            multi: true
        },
        // { provide: RouterStateSerializer, useClass: CustomSerializer },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        NgxPermissionsService,
        {
            provide: APP_INITIALIZER,
            useFactory: (uaaService: UserManagementService, initTranslationService: InitTranslationService) => {
                return (async () => {
                    await initTranslationService.initTranslations();
                    // await uaaService.authRole();
                });
            },
            deps: [UserManagementService, InitTranslationService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
